import { UPDATE_ACTIVE_STAGE_INDEX, FLUSH_QUERY } from "../../actions/QueryBuilder/actionConstants";

const activeStageIdx = (state = 0, action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type
		 *  activeStageIdx
		 * }
		 */
		case UPDATE_ACTIVE_STAGE_INDEX:
			return action.activeStageIdx;
		case FLUSH_QUERY:
			return -1;
		default:
			return state;
	}
};

export default activeStageIdx;
